export const UPDATE_EMAIL_PASSWORD_DIMENTICATA = 'UPDATE_EMAIL_PASSWORD_DIMENTICATA';
export const SALVA_DATI_PASSWORD_DIMENTICATA   = 'SALVA_DATI_PASSWORD_DIMENTICATA';
export const INVIA_DATI_PASSWORD_DIMENTICATA   = 'INVIA_DATI_PASSWORD_DIMENTICATA';

